import createIcon from '../../createIcon';

/**
 * @component @name FactCheck
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIwIDNINEMyLjkgMyAyIDMuOSAyIDVWMTlDMiAyMC4xIDIuOSAyMSA0IDIxSDIwQzIxLjEgMjEgMjIgMjAuMSAyMiAxOVY1QzIyIDMuOSAyMS4xIDMgMjAgM1pNMTAgMTdINVYxNUgxMFYxN1pNMTAgMTNINVYxMUgxMFYxM1pNMTAgOUg1VjdIMTBWOVpNMTQuODIgMTVMMTIgMTIuMTZMMTMuNDEgMTAuNzVMMTQuODIgMTIuMTdMMTcuOTkgOUwxOS40MSAxMC40MkwxNC44MiAxNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FactCheck = createIcon('FactCheck', [
  [
    'path',
    {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M20 3H4C2.9 3 2 3.9 2 5V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V5C22 3.9 21.1 3 20 3ZM10 17H5V15H10V17ZM10 13H5V11H10V13ZM10 9H5V7H10V9ZM14.82 15L12 12.16L13.41 10.75L14.82 12.17L17.99 9L19.41 10.42L14.82 15Z',
      key: '1xkamu',
    },
  ],
]);

export default FactCheck;
